var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 0.166748C13.5547 0.166748 15.1656 0.834008 16.3533 2.02174C17.541 3.20947 18.2083 4.82038 18.2083 6.50008C18.2083 8.17979 17.541 9.79069 16.3533 10.9784C15.1656 12.1662 13.5547 12.8334 11.875 12.8334C10.1953 12.8334 8.58435 12.1662 7.39662 10.9784C6.20889 9.79069 5.54163 8.17979 5.54163 6.50008C5.54163 4.82038 6.20889 3.20947 7.39662 2.02174C8.58435 0.834008 10.1953 0.166748 11.875 0.166748ZM11.875 11.2501C13.1347 11.2501 14.3429 10.7496 15.2337 9.85884C16.1245 8.96804 16.625 7.75986 16.625 6.50008C16.625 5.2403 16.1245 4.03212 15.2337 3.14132C14.3429 2.25053 13.1347 1.75008 11.875 1.75008C10.6152 1.75008 9.407 2.25053 8.5162 3.14132C7.6254 4.03212 7.12496 5.2403 7.12496 6.50008C7.12496 7.75986 7.6254 8.96804 8.5162 9.85884C9.407 10.7496 10.6152 11.2501 11.875 11.2501ZM2.37496 6.50008C2.37492 7.4817 2.67952 8.43915 3.24671 9.24031C3.81391 10.0415 4.61576 10.6469 5.54163 10.973V12.6276C2.81038 11.923 0.791626 9.453 0.791626 6.50008C0.791626 3.54716 2.81038 1.07716 5.54163 0.372582V2.02716C3.69704 2.67633 2.37496 4.43383 2.37496 6.50008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenWhite);
export default __webpack_public_path__ + "static/media/tokenWhite.594a01d0a347fd0079714b2ba4a2bca7.svg";
export { ForwardRef as ReactComponent };